<template>
    <div v-if="itemDoc != null">
        <v-form ref="itemDocEditform" v-model="itemDocEditFormValid" lazy-validation>

            <v-card>
                <v-toolbar dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title>{{title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        label="Category"
                        v-bind:items="docCategories"
                        v-model="itemDoc.docCategoryId"
                        item-text="name"
                        item-value="id"
                        hint=""
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                    <v-flex xs12>
                        <v-select
                        :rules="[rules.required]"
                        label="Status"
                        v-bind:items="docStatuses"
                        v-model="itemDoc.status"
                        item-text="name"
                        item-value="id"
                        hint="Users will NOT see Inactive Document in Item/Product Search page"
                        persistent-hint
                        ></v-select>
                    </v-flex>    
                    <v-flex xs12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="itemDoc.docName" 
                            label="Name"
                            ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12>
                        <v-text-field 
                            :rules="[rules.required]"
                            v-model="itemDoc.docUrl" 
                            label="Url"
                            hint="Must be an Unique Value"
                            ></v-text-field>
                    </v-flex>
                </v-card-text>
                <v-card-actions class="white hide">
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="save()">
                    Submit
                    </v-btn>
                    <v-btn class="info" @click="cancel()">
                    Cancel
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- {{itemDoc}} -->
    </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
    props: ['itemDoc'],
    data () {
        return {
            // itemDoc: {},
            docCategories: [
                // {id: 'brochure', name: 'Brochure'},
                // {id: 'priceList', name: 'Price List'},
                // {id: 'ifu', name: 'IFU'},
                // {id: 'memo', name: 'Memo'},
                // {id: 'sds', name: 'SDS'},
                {id: 'productUrl', name: 'ProductUrl'},
            ],
            docStatuses: [
                {id: 'active', name: 'Active'},
                {id: 'inactive', name: 'Inactive'},
            ],
            itemDocEditFormValid: true,
            rules: {
                required: v => !!v || "This field is required"
            },

        }
    },
    computed: {
        // id () {
        //     return this.$route.params.id
        // },
        isNew () {
            return !this.id
        },
        title () {
            return this.isNew?'Add Document' : 'Edit Document'
        }
    },
    methods: {
        ...mapActions('adminItemProdDb', [
            // 'populateRegionEditModel',
            'saveItmDoc'
        ]),
        async save() {
            if (this.$refs.itemDocEditform.validate()) {
                var result = await this.saveItmDoc(this.itemDoc)
                this.$emit('onCloseItmDocEdit')
            }
            // this.$router.push({name: 'admin-regions'})
        },
        cancel() {
            // this causes data reload, even it is not necessary
            this.$emit('onCloseItmDocEdit')

            // this.$router.push({name: 'admin-regions'})
        },
    },
    watch: {
        // id: async function (newValue) {
        //     this.itemDoc = await this.populateRegionEditModel(newValue)

        // }
    },
    async created () {
    }
}
</script>
